import * as React from "react";
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { ToastComponent } from '@syncfusion/ej2-react-notifications';
import i18n from 'i18next';
import './contacts.scss';
import LexonComponentCalendar from "../../apps/lexon_content_calendar";


export class ContactsImport extends React.Component {
  constructor(props) {
    super(props);

    this.toasts = [
      { content: i18n.t("schedule.toast-processing"), cssClass: 'e-toast-black', icon: '' },
      { content: i18n.t("schedule.toast-process-complete"), cssClass: 'e-toast-black', icon: '' },
      { content: i18n.t("schedule.toast-process-error"), cssClass: 'e-toast-danger', icon: 'e-error toast-icons' },
      { content: i18n.t("schedule.toast-process-error-exist"), cssClass: 'e-toast-danger', icon: 'e-error toast-icons' }
    ];
  }

    toastCusAnimation = {
      hide: { duration: '1' },
      show: { duration: '200' }
    };

    componentDidMount() {}

    onPressActionButton() {}

    componentDidUpdate() {}

    CheckEnterKey() {
      this.state.name = this.TitleTypeEventObj.value;
    }

    render() {
      return (
        <div id="lexon-app-import-events" className="row custom-margin custom-padding-5 material2">
          <div className="col-xs-12 col-sm-12 col-lg-12 col-md-12">
            <div className="Ccontainer" >
              <LexonComponentCalendar />
              <div className="e-footer-content">
                <ButtonComponent
                  id="newevent"
                  cssClass='hidden e-control e-btn e-lib e-primary e-event-save e-flat'
                  onClick={this.onPressActionButton.bind(this)}
                  ref={scope => {
                    this.addBtn = scope;
                  }}
                > Aceptar</ButtonComponent>
              </div>
            </div>

            <ToastComponent ref={toast => {
              this.toastObj = toast;
            }}
            id='toast_pos'
            content='Action successfully completed.'
            position={this.position}
            target={this.target}
            animation={this.toastCusAnimation}
            timeOut={2000}
            >
            </ToastComponent>

          </div>
        </div>
      );
    }
}

export default ContactsImport;


